<template>
  <div class=" h-100 d-flex align-items-center justify-center">
    <img src="../../assets/images/empty-data.png" />
  </div>
</template>
<script>
export default {
}
</script>
<style scoped>
  div {
    margin: 0 auto;
  }
  div > img {
    height: 250px !important;
    width: 250px;
  }
</style>
